import { Airport } from '../types'

// TODO: Move to common
export const formatAirport = (airport: Airport): string => {
  return [airport.airport_name, airport.airport_country].filter((x) => !!x).join(', ')
}
